// Environment-aware logger: silent in production builds
const enabled = process.env.NODE_ENV !== "production";

export const logError = (...args) => { if (enabled) console.error(...args); };
export const logWarn = (...args) => { if (enabled) console.warn(...args); };
